<template>
    <title-page :title="title" />
    <div class="show-all__result">
        <multi-line-view
            ref="multiLine"
            :items="props.items"
            :line-id="props.lineId"
            @list-item-selected="itemsSelected"
            @add-list-items="requestMore"
        />
    </div>
    <div v-show="props.isLoading" class="lines-loader">
        <loader />
    </div>
</template>

<script lang="ts" setup>
    import { type PropType, ref, type Ref, onMounted, watch, nextTick } from "vue";
    import { type CardData } from '@/components/Cards/types';
    import { useParentControl } from "@/composables/parentControl/useParentControl";
    import { useApplicationStore } from "@/stores/Application";
    import { useParentControlStore } from "@/stores/ParentControl";
    import { storeToRefs } from 'pinia'
    import { useDetailPageStore } from "@/stores/DetailPage";
    import type { MultiLineViewRef, IEventSelected } from "@/components/MultiLineView/types";
    import { useFocus } from "@/composables/useFocus";
    import { AppConstants } from "@/common";

    const { setIsHaveFocusedElement, focusElementLine } = useFocus();

    const {
        clearAllDetailPage
    } = useDetailPageStore();

    const ApplicationStore = useApplicationStore();
    const {
        getIsHaveFocusedElement: isHavSelectedIdProgram,
    } = storeToRefs(ApplicationStore);

    const ParentControlStoreModule = useParentControlStore();
    const {
        ShowParentModal,
        SetTargetWidgetAdultControl,
        SetIncorrectAdultPin,
    } = ParentControlStoreModule;
    const {
        getIsAdultPinCorrect: isAdultPinCorrect,
        getTargetWidgetAdultControl: targetWidgetAdultControl,
    } = storeToRefs(ParentControlStoreModule);

    const emit = defineEmits(['request-more', 'item-selected']);

    const props = defineProps({
        items: {
            type: [Array, null] as PropType<CardData[] | null>,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: true,
        },
        lineId: {
            type: String,
            required: false,
            default: AppConstants.shelfKeys.showAll,
        },
    });

    const name = "ShowAllNew";

    const { setCurrentTimes, checkParentControlCard } = useParentControl();
    const selectedItem: Ref<IEventSelected | null> = ref(null);
    const multiLine: Ref<MultiLineViewRef | null> = ref(null);

    const requestMore = (): void => {
        emit("request-more");
    };
    const onListItemSelected = (): void => {
        emit("item-selected", selectedItem.value);
    };
    const itemsSelected = (event: IEventSelected): void => {
        selectedItem.value = event;
        checkParentControlCard(event).then((isAllow)=>{
            if (isAllow) {
                onListItemSelected();
            } else {
                ShowParentModal();
                SetTargetWidgetAdultControl(name);
            }
        });
    };

    const focusElement = () => {
        if (isHavSelectedIdProgram.value) {
            focusElementLine();
        } else {
            setFirstFocused();
        }
    };

    const setFirstFocused = () => {
        if (multiLine.value) {
            multiLine.value.setFirstFocused();
        }
    };

    onMounted((): void => {
        clearAllDetailPage();
        nextTick(()=>{
            setIsHaveFocusedElement();
            focusElement();
        });
    });


    watch(
        isAdultPinCorrect, 
        (value: boolean) => {
        if (value && name === targetWidgetAdultControl.value) {
            SetIncorrectAdultPin();
            setCurrentTimes();
            onListItemSelected();
        }
    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>

